
//Import React Hooks
import { useEffect, useState } from 'react'

//Import created components
import CreneauManager from '../../components/creneaumanager/CreneauManager.jsx'

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';


//MUI

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

//data
import mareesList from '../../data/marees.json';


//Utils 
import convertHoraire from '../../utils/convert_horaire.js';
import filterCreneaux from '../../utils/filterCreneaux.js';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)



function JourneeManager({ nbjour, date }) {

    let [showMarees, setShowMarees] = useState(false);
    let [creneaux, setCreneaux] = useState([]);
    let [newCreneau, setNewCreneau] = useState();

    let jourSemaine = ["lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

    let mareesVide = { //pour les jours non présents dans maree.json

        date: "-",
        coef: [
            "-",
            "-"
        ],
        pm: [
            "-",
            "-"
        ],
        bm: [
            "-",
            "-"
        ]
    };

    let mareesDuJour = mareesList.find((jour) => (jour.date === dayjs(date).format('YYYY-MM-DD'))) || mareesVide;
    //console.log(mareesDuJour);

    useEffect(() => {
        async function initCreneaux() { //we add this inner function to manage asynchrone
            let creneauxDuJour = await getCreneaux(dayjs(date).format('YYYY-MM-DD'));
            setCreneaux([].concat(creneauxDuJour.sort(
                (p1, p2) => (p1.horaire < p2.horaire) ? -1 : (p1.horaire > p2.horaire) ? 1 : 0)));


        } //end of async function


        initCreneaux(); //call the inner asnchrone function
        setShowMarees(false); //close Marees tab


    }, [date, newCreneau])


    async function getCreneaux(jour) { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/creneau/${jour}`,
            });
            //console.log(response);
            const crens = response.data;
            return crens;
        } catch (err) {
            console.error(err);
            return null;
        }
    }









    return (
        <div className="calendar-days-journee">
            <h3 className="calendar-days-journee-title h3-manager">{jourSemaine[nbjour - 1] + "\n " + dayjs(date).format('DD/M')}</h3>

            <div className="calendar-days-journee-marees color-manager">
                <div className="calendar-days-journee-marees-header " onClick={_ => setShowMarees(!showMarees)}>
                    <p>Marées</p>
                    {showMarees == false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}

                </div>
                {showMarees == true ?
                    <div className="calendar-days-journee-marees-content">
                        <table>
                            <tr>
                                <th>Basse</th>
                                <td>{mareesDuJour.bm[0]}</td>
                                <td>{mareesDuJour.bm[1] && mareesDuJour.bm[1]}</td>
                            </tr>
                            <tr>
                                <th>Haute</th>
                                <td>{mareesDuJour.pm[0]}</td>
                                <td>{mareesDuJour.pm[1] && mareesDuJour.pm[1]}</td>
                            </tr>
                            <tr>
                                <th>Coef.</th>
                                <td>{mareesDuJour.coef[0]}</td>
                                <td>{mareesDuJour.coef[1] && mareesDuJour.coef[1]}</td>
                            </tr>
                        </table>
                    </div>
                    : null
                }


            </div>

            <div className="calendar-days-journee-creneaux">

                {creneaux.map((creneau) => (
                    <CreneauManager key={creneau.id_creneau} creneau={creneau} />
                ))}


            </div>

        </div>
    );
}

export default JourneeManager;